module.exports = __webpack_public_path__ + "static/img/about_img_b.c9ff4f8d.png";